import { Request } from '../utilities/Request';

export function add_stock_item_to_purchase_order(this_obj, stock_item_data) {
  return Request.post(
    this_obj,
    `/api/purchase_orders/${stock_item_data.po_id}/purchase_order_stock_items`,
    null,
    {
      stock_item_id: stock_item_data.stock_item_id,
      quantity: stock_item_data.quantity,
      purchased_quantity: stock_item_data.purchased_quantity,
      unit_price: stock_item_data.unit_price,
      branch_id: stock_item_data.branch_id,
      allocated: stock_item_data.allocated_price_desc
    }
  );
}

export function get_stock_items_for_purchase_order(this_obj, purchase_order_id) {
  return Request.get(
    this_obj,
    `/api/purchase_orders/${purchase_order_id}/purchase_order_stock_items`,
    null
  );
}

export function delete_stock_item_from_purchase_order(this_obj, id) {
  return Request.delete(
    this_obj,
    `/api/delete_stock_item_from_purchase_order/${id}`,
    null
  );
}

export function create_new_po_with_stock_items(this_obj, stock_item_ids, po_id) {
  return Request.post(
    this_obj,
    '/api/create_new_po_with_stock_items',
    null,
    {
      stock_item_ids: stock_item_ids,
      po_id: po_id
    }
  );
}
